import { getOutgoers } from '@xyflow/react';
import { type FlowEdge, type FlowNode, type ConnectionData } from '@app/services/aiFlow.types';

function isValidFlow(connection: ConnectionData) {
    if (!connection.targetHandle.includes('flow-target')) {
        return false;
    } else if (connection.targetHandle.startsWith('question')) {
        return (
            connection.sourceHandle.startsWith('section') ||
            connection.sourceHandle.startsWith('question')
        );
    } else {
        return true;
    }
}
// function isValidFlow(connection: ConnectionData) {
//     if (!connection.targetHandle.includes('flow-target')) {
//         return false;
//     } else if (connection.sourceHandle.startsWith('section')) {
//         return connection.targetHandle === 'question-flow-target';
//     } else if (connection.sourceHandle.startsWith('action')) {
//         return connection.targetHandle !== 'question-flow-target';
//     } else {
//         // source is question, target is any flow-target
//         return true;
//     }
// }

function isValidHandleConnection(connection: ConnectionData) {
    const { sourceHandle, targetHandle } = connection;
    if (sourceHandle.includes('flow-source')) {
        return isValidFlow(connection);
    } else if (sourceHandle.includes('complete-source') || sourceHandle.match(/value:.*-source$/)) {
        return targetHandle.startsWith('condition-target');
    }
}

// Combined validation for ReactFlow
export function isValidConnection(
    connection: ConnectionData,
    nodes: FlowNode[],
    edges: FlowEdge[]
) {
    if (!isValidHandleConnection(connection)) {
        return false;
    }
    // Self-loop check
    if (connection.target === connection.source) {
        return false;
    }
    // Cycle detection (only for flow connections)
    if (connection.sourceHandle.includes('flow-source')) {
        const target = nodes.find((node) => node.id === connection.target);

        const hasCycle = (node: FlowNode | undefined, visited = new Set()) => {
            if (!node || visited.has(node?.id)) return false;
            visited.add(node.id);

            for (const outgoer of getOutgoers(node, nodes, edges)) {
                if (outgoer.id === connection.source) return true;
                if (hasCycle(outgoer, visited)) return true;
            }
            return false;
        };
        return !hasCycle(target);
    }
    return true;
}

export function isNodeComplete(node: FlowNode): boolean {
    const isNotEmpty = (value: string) => value.trim().length > 0;
    if (node.type === 'section' || node.type === 'action') {
        return isNotEmpty(node.data.name) && isNotEmpty(node.data.description);
    } else if (node.type === 'question') {
        return isNotEmpty(node.data.text);
    } else if (node.type === 'decision') {
        return (
            isNotEmpty(node.data.name) &&
            isNotEmpty(node.data.decisionVariable) &&
            isNotEmpty(node.data.passed) &&
            isNotEmpty(node.data.failed)
        );
    } else {
        return false;
    }
}
